import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-home",
  templateUrl: "./med-icon-home.component.html",
})
export class MedIconHomeComponent extends SvgMixinComponent {}
